import { FormErrors } from "redux-form"
import { ValidationGenerator } from "../../../../../form/validation/validation-generator"
import { SurveyValidationSetting } from "../../../../../form/validation/validation-setting"
import { ICreateSelectSurveyProps } from "./index"

export const validate = (values: ICreateSelectSurveyProps) => {
  const errors: FormErrors<ICreateSelectSurveyProps> = {}

  const titleVal = ValidationGenerator(
    values.title,
    SurveyValidationSetting.title,
  )
  if (titleVal) {
    errors.title = titleVal
  }

  if (values.answers === undefined || values.answers.length < 2) {
    // @ts-ignore
    errors.answers = { _error: "回答は最低2つ必要です" }
  } else {
    // @ts-ignore
    errors.answers = []
    values.answers.forEach((v, i) => {
      const answerItemVal = ValidationGenerator(
        v,
        SurveyValidationSetting.answer,
      )
      if (answerItemVal) {
        errors.answers![i] = answerItemVal
      }
    })
  }

  return errors
}
